import { render } from "./InvalidConfiguration.vue?vue&type=template&id=57cfe966"
import script from "./InvalidConfiguration.vue?vue&type=script&lang=js"
export * from "./InvalidConfiguration.vue?vue&type=script&lang=js"
script.render = render

export default script